module.exports = __webpack_public_path__ + "img/Logo_IC_Outubro_Rosa.2589f3a5.svg";